module.exports = __webpack_public_path__ + "static/img/nav07.5ebf0620.png";